import { capitalize, generateUtilityClass, unstable_composeClasses } from "@mui/material";
import { toolbarButtonGroupName } from "../classes.js";
function getUtilityClass(slot) {
  return generateUtilityClass(toolbarButtonGroupName, slot);
}
function useUtilityClasses(ownerState) {
  const { anchor, classes, divider, showLabels } = ownerState;
  const labelsState = capitalize(showLabels ? "on" : "off");
  const slots = {
    buttonStack: ["buttonStack"],
    divider: ["divider"],
    root: [
      "buttonStack",
      "root",
      `labels${labelsState}`,
      anchor && `anchor${capitalize(anchor)}`,
      divider && `divider`
    ]
  };
  return unstable_composeClasses(slots, getUtilityClass, classes);
}
export {
  useUtilityClasses
};
//# sourceMappingURL=useUtilityClasses.js.map
